// ═══════════════════════════════════════════════════════
// Schoolizy — Helpers RBAC
// Définit les permissions par rôle
// ═══════════════════════════════════════════════════════

export const ROLES = {
  ADMIN_ECOLE:   'ADMIN_ECOLE',
  DIRECTEUR:     'DIRECTEUR',
  PROVISEUR:     'PROVISEUR',
  CENSEUR:       'CENSEUR',
  SURVEILLANT:   'SURVEILLANT',
  SECRETAIRE:    'SECRETAIRE',
  COMPTABLE:     'COMPTABLE',
  ENSEIGNANT:    'ENSEIGNANT',
  BIBLIOTHECAIRE:'BIBLIOTHECAIRE',
  PARENT:        'PARENT',
  ELEVE:         'ELEVE',
  SUPER_ADMIN:   'SUPER_ADMIN',
};

// Groupes de rôles pour les vérifications rapides
export const ROLE_GROUPS = {
  DIRECTION:     [ROLES.ADMIN_ECOLE, ROLES.DIRECTEUR, ROLES.PROVISEUR, ROLES.CENSEUR],
  PEDAGOGIQUE:   [ROLES.ADMIN_ECOLE, ROLES.DIRECTEUR, ROLES.PROVISEUR, ROLES.CENSEUR, ROLES.ENSEIGNANT],
  ADMINISTRATIF: [ROLES.ADMIN_ECOLE, ROLES.SECRETAIRE, ROLES.COMPTABLE],
  FINANCES:      [ROLES.ADMIN_ECOLE, ROLES.COMPTABLE, ROLES.SECRETAIRE],
  ALL_STAFF:     [ROLES.ADMIN_ECOLE, ROLES.DIRECTEUR, ROLES.PROVISEUR, ROLES.CENSEUR, ROLES.SURVEILLANT, ROLES.SECRETAIRE, ROLES.COMPTABLE, ROLES.ENSEIGNANT, ROLES.BIBLIOTHECAIRE],
};

// Permissions par section
export const PERMISSIONS = {
  // Tableau de bord
  dashboard:            [...ROLE_GROUPS.ALL_STAFF, ROLES.PARENT, ROLES.ELEVE],
  dashboardEnseignant:  [ROLES.ENSEIGNANT, ROLES.ADMIN_ECOLE],

  // Scolarité
  eleves:               [...ROLE_GROUPS.ALL_STAFF],
  admissions:           [ROLES.ADMIN_ECOLE, ROLES.SECRETAIRE, ROLES.DIRECTEUR],
  presences:            [...ROLE_GROUPS.PEDAGOGIQUE, ROLES.SURVEILLANT, ROLES.SECRETAIRE],
  rapportAbsences:      [...ROLE_GROUPS.DIRECTION, ROLES.SECRETAIRE],
  vieScolaire:          [...ROLE_GROUPS.DIRECTION, ROLES.SURVEILLANT, ROLES.SECRETAIRE],
  sante:                [ROLES.ADMIN_ECOLE, ROLES.DIRECTEUR, ROLES.SECRETAIRE],
  formulaires:          [...ROLE_GROUPS.DIRECTION, ROLES.SECRETAIRE],

  // Pédagogie
  evaluations:          [...ROLE_GROUPS.PEDAGOGIQUE],
  bulletins:            [...ROLE_GROUPS.PEDAGOGIQUE, ROLES.SECRETAIRE],
  cahierTexte:          [...ROLE_GROUPS.PEDAGOGIQUE],
  validationNotes:      [ROLES.ADMIN_ECOLE, ROLES.DIRECTEUR, ROLES.PROVISEUR],
  classements:          [...ROLE_GROUPS.PEDAGOGIQUE, ROLES.SECRETAIRE],
  rapportsPedago:       [...ROLE_GROUPS.DIRECTION],

  // Emploi du temps
  emploiDuTemps:        [...ROLE_GROUPS.PEDAGOGIQUE, ROLES.SECRETAIRE],

  // Finance
  finance:              [ROLES.ADMIN_ECOLE, ROLES.COMPTABLE, ROLES.SECRETAIRE],
  tresorerie:           [ROLES.ADMIN_ECOLE, ROLES.COMPTABLE],
  paiements:            [ROLES.ADMIN_ECOLE, ROLES.COMPTABLE, ROLES.SECRETAIRE],

  // RH
  personnel:            [ROLES.ADMIN_ECOLE, ROLES.DIRECTEUR, ROLES.SECRETAIRE],
  portailEnseignant:    [ROLES.ENSEIGNANT, ROLES.ADMIN_ECOLE],
  contrats:             [ROLES.ADMIN_ECOLE, ROLES.DIRECTEUR],
  conges:               [ROLES.ADMIN_ECOLE, ROLES.DIRECTEUR, ROLES.SECRETAIRE],

  // Bibliothèque
  bibliotheque:         [...ROLE_GROUPS.ALL_STAFF],

  // Logistique
  stocks:               [ROLES.ADMIN_ECOLE, ROLES.COMPTABLE, ROLES.SECRETAIRE],

  // Communication
  communication:        [...ROLE_GROUPS.ALL_STAFF],
  annonces:             [...ROLE_GROUPS.DIRECTION, ROLES.SECRETAIRE],

  // Établissement
  etablissement:        [ROLES.ADMIN_ECOLE, ROLES.DIRECTEUR],
  structure:            [ROLES.ADMIN_ECOLE],

  // Admin
  gestionRoles:         [ROLES.ADMIN_ECOLE, ROLES.SUPER_ADMIN],
};

// Vérifier si un utilisateur a accès à une permission
export function hasPermission(userRoles = [], permission) {
  if (!userRoles || !permission) return false;
  const allowed = PERMISSIONS[permission] || [];
  return userRoles.some((r) => allowed.includes(r) || r === ROLES.SUPER_ADMIN);
}

// Vérifier si un utilisateur a au moins un des rôles donnés
export function hasRole(userRoles = [], ...roles) {
  if (!userRoles) return false;
  return roles.some((r) => userRoles.includes(r));
}

// Obtenir le label d'un rôle
export const ROLE_LABELS = {
  SUPER_ADMIN:    'Super Admin',
  ADMIN_ECOLE:    'Administrateur',
  DIRECTEUR:      'Directeur',
  PROVISEUR:      'Proviseur',
  CENSEUR:        'Censeur',
  SURVEILLANT:    'Surveillant',
  SECRETAIRE:     'Secrétaire',
  COMPTABLE:      'Comptable / Caissier',
  ENSEIGNANT:     'Enseignant',
  BIBLIOTHECAIRE: 'Bibliothécaire',
  PARENT:         'Parent',
  ELEVE:          'Élève',
};

export const ROLE_COLORS = {
  SUPER_ADMIN:    '#dc2626',
  ADMIN_ECOLE:    '#0f2744',
  DIRECTEUR:      '#7c3aed',
  PROVISEUR:      '#7c3aed',
  CENSEUR:        '#8b5cf6',
  SURVEILLANT:    '#64748b',
  SECRETAIRE:     '#d97706',
  COMPTABLE:      '#16a34a',
  ENSEIGNANT:     '#3b82f6',
  BIBLIOTHECAIRE: '#0891b2',
  PARENT:         '#e11d48',
  ELEVE:          '#f97316',
};
